<div class="paper fax-rule-list" (clickOutside)="deselectRule()">
  <app-fax-filter-list-wrapper title="Rules">
    <ng-container *ngIf="!isLoading; else rulesSkeleton">
      <li *ngFor="let item of items" class="fax-rule-list__item" (click)="selectRule(item)">
        <button class="icon-btn icon-btn_md" (click)="$event.stopPropagation(); editClick.emit(item)">
          <span class="fax-rule-list__edit-icon"></span>
        </button>

        {{ formatRuleToString(item) }}
      </li>
    </ng-container>

    <ng-template #rulesSkeleton>
      <li *ngFor="let row of skeletonRows" class="fax-rule-list__item fax-rule-list__item_skeleton">
        <span class="skeleton fax-rule-list__item-skeleton"></span>
      </li>
    </ng-template>
  </app-fax-filter-list-wrapper>

  <app-fax-filter-list-form
    [value]="selectedRuleName"
    [readOnly]="true"
    [createRequiresValue]="false"
    placeholder="To add rule press +"
    (createClick)="onCreateClick()"
    (deleteClick)="onDeleteClick()"
  ></app-fax-filter-list-form>
</div>
